<footer class="d-flex justify-content-between pos-relative">
    <div class="version mx-2">v.{{ appVersion }}</div>
</footer>

